module.exports = __webpack_public_path__ + "img/huaxia.f1636b55.png";